import React from 'react';
import Card from './../../common/cards/Card';
import styles from './BirthdayCard.module.scss';
import Avatar from '@material-ui/core/Avatar';
import DefaultAvatar from '../../../assets/icons/svgIcons/avatar.svg';
import { presentationBirthday } from '../../../helpers/date';
import Badge from '@material-ui/core/Badge';
import Tag from '../../common/Tag';
import { routes } from '../../../assets/routes';
import { generatePath, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { useTranslation } from '../../../i18n/LanguageProvider';

const BirthdayCard = (props) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <Card {...props}>
      <div className={styles.wrapper}>
        <div className={styles.body}>
          <div className={styles.avatar}>
            <Badge
              invisible={false}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              badgeContent={
                (props.isToday && (
                  <Tag anim={true} color="secondary" name={t('common.today')} />
                )) ||
                (props.isTomorrow && (
                  <Tag
                    anim={true}
                    color="primary"
                    name={t('common.tomorrow')}
                  />
                ))
              }
            >
              <Avatar
                src={props.user.avatar?.thumbnail || DefaultAvatar}
                alt="kudos card"
              />
            </Badge>
          </div>
          <div
            className={styles.info}
            onClick={() => {
              history.push(generatePath(routes.PROFILE, { id: props.user.id }));
            }}
          >
            <div className={styles.name} dir="auto">
              {`${props.user.first_name} ${props.user.last_name}`}
            </div>
            <div className={styles.date}>
              {presentationBirthday(props.user.birthday)}
            </div>
          </div>
          <div className={styles.button}>
            <Button
              variant="outlined"
              onClick={() => {
                const user = {
                  id: +props.user.id,
                  name: `${props.user.first_name} ${props.user.last_name}`,
                  img: props.user?.avatar?.thumbnail,
                  birthday: true
                };
                history.push(routes.GIVE_KUDOS, [user]);
              }}
              size="small"
            >
              {t('occasions.congratulate')}
            </Button>
          </div>
        </div>
      </div>
    </Card>
  );
};

BirthdayCard.propTypes = {
  extraClass: PropTypes.string,
  user: PropTypes.shape({
    id: PropTypes.number,
    img: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    avatar: PropTypes.shape({
      thumbnail: PropTypes.string
    }),
    birthday: PropTypes.string
  }),
  isToday: PropTypes.bool,
  isTomorrow: PropTypes.bool
};

export default BirthdayCard;
